import React from 'react';
import { Link } from 'react-router-dom';
import StaticPage, { SUPPORT_EMAIL } from './StaticPage';

/** TCH-16-FR-12 — Contact. */
const Contact: React.FC = () => (
  <StaticPage title="Contacto" intro="Cómo llegar a nosotros.">
    <p style={{ color: '#444', fontSize: 15 }}>
      Escríbenos a <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>. Respondemos en días
      hábiles.
    </p>
    <p style={{ color: '#444', fontSize: 15 }}>
      Para dudas sobre una sesión o un pago, incluye el nombre del curso y la fecha. Muchas
      preguntas ya están resueltas en el <Link to="/help">centro de ayuda</Link>.
    </p>
  </StaticPage>
);

export default Contact;
